import React, { useState, useEffect, useContext } from 'react'
import FormattedObject from '../components/FormattedObject'
import { getScale } from '../api'
import Scale from '../components/Scale'
import { valid } from 'chroma-js'
import InputGroup from '../components/InputGroup'
import { ScaleContext } from '../index'

function ColorSection() {
	const { setGlobalScale } = useContext(ScaleContext)

	const modes = ['lab', 'rgb', 'lrgb', 'hsl', 'lch']
	const [mode, setMode] = useState(modes[0])
	const [color, setColor] = useState('#f00')
	const [amount, setAmount] = useState(10)
	const [corrected, setCorrected] = useState(true)

	const inputProps = {
		modes,
		mode,
		setMode,
		color,
		setColor,
		amount,
		setAmount,
		corrected,
		setCorrected,
	}

	const [scale, setScale] = useState(getScale(color, mode, amount, corrected))
	useEffect(() => {
		if (valid(color)) {
			setScale(getScale(color, mode, amount, corrected))
		}
	}, [mode, color, amount, corrected])

	useEffect(() => {
		setGlobalScale(scale)
	}, [scale, setGlobalScale])

	return (
		<div>
			<InputGroup {...inputProps} />
			<div className="p-4 flex sm:flex-row flex-col-reverse sm:space-x-10">
				<Scale scale={scale} />
				<code className="text-black mb-8 sm:mb-0">
					<FormattedObject name="myColor" scale={scale} />
				</code>
			</div>
		</div>
	)
}

export default ColorSection
